import { useMemo } from "react";
import { motion, useReducedMotion } from "framer-motion";

export default function Bubbles() {
  const reduce = useReducedMotion();
  const bubbles = useMemo(
    () =>
      Array.from({ length: 18 }, (_, i) => ({
        id: i,
        left: 2 + Math.random() * 96,
        size: 4 + Math.random() * 14,
        duration: 12 + Math.random() * 10,
        delay: Math.random() * 14,
      })),
    []
  );

  if (reduce) return null;

  return (
    <div
      className="pointer-events-none fixed inset-0 z-[1] overflow-hidden"
      aria-hidden="true"
      data-testid="bubble-field"
    >
      {bubbles.map((b) => (
        <motion.span
          key={b.id}
          className="absolute top-0"
          style={{ left: `${b.left}%` }}
          initial={{ y: "112vh", opacity: 0 }}
          animate={{ y: "-12vh", opacity: [0, 0.85, 0.85, 0] }}
          transition={{
            duration: b.duration,
            delay: b.delay,
            repeat: Infinity,
            ease: "linear",
            times: [0, 0.1, 0.85, 1],
          }}
        >
          <span
            className="bubble"
            style={{
              width: b.size,
              height: b.size,
              animationDuration: `${2.6 + (b.id % 4) * 0.7}s`,
            }}
          />
        </motion.span>
      ))}
    </div>
  );
}
